import { z } from "zod";

export const OutcomeDirectionSchema = z.enum(["improved", "worsened", "flat"]);

export const OutcomeComparisonSchema = z.object({
	previousValue: z.number().nonnegative().nullable(),
	delta: z.number().nullable(),
	direction: OutcomeDirectionSchema.nullable(),
});

export const NoShowByEventTypeSchema = z.object({
	eventType: z.string().min(1),
	completed: z.number().int().nonnegative(),
	noShows: z.number().int().nonnegative(),
	resolved: z.number().int().positive(),
	rate: z.number().min(0).max(100),
});

export const ContainmentOutcomeSchema = z.object({
	rate: z.number().min(0).max(100),
	aiEngagedConversations: z.number().int().positive(),
	handoffRequestedConversations: z.number().int().nonnegative(),
	comparison: OutcomeComparisonSchema,
});

export const NoShowOutcomeSchema = z.object({
	rate: z.number().min(0).max(100),
	completed: z.number().int().nonnegative(),
	noShows: z.number().int().nonnegative(),
	resolved: z.number().int().positive(),
	byEventType: z.array(NoShowByEventTypeSchema),
	comparison: OutcomeComparisonSchema,
});

export const TimeToBookingOutcomeSchema = z.object({
	medianMinutes: z.number().nonnegative(),
	sampleCount: z.number().int().positive(),
	comparison: OutcomeComparisonSchema,
});

export const DashboardOutcomeSnapshotSchema = z.object({
	containment: ContainmentOutcomeSchema.nullable(),
	noShow: NoShowOutcomeSchema.nullable(),
	timeToBooking: TimeToBookingOutcomeSchema.nullable(),
});

export type DashboardOutcomeSnapshot = z.infer<
	typeof DashboardOutcomeSnapshotSchema
>;
